
import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="py-12 md:py-20 bg-[#ebe960]">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
          まずはお気軽にご相談ください
        </h2>
        <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-800 mb-6 md:mb-10">
          お見積もり無料・24時間受付中
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
          <a
            href="tel:0120-743-643"
            className="inline-flex items-center justify-center gap-2 md:gap-3 bg-gray-900 text-white px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 rounded-full text-base sm:text-lg md:text-xl font-bold hover:bg-gray-800 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill text-lg sm:text-xl md:text-2xl"></i>
            0120-743-643
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 md:gap-3 bg-white text-gray-900 px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 rounded-full text-base sm:text-lg md:text-xl font-bold hover:bg-gray-100 transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
          >
            <i className="ri-mail-fill text-lg sm:text-xl md:text-2xl"></i>
            お問い合わせフォーム
          </Link>
        </div>

        <a
          href="https://lin.ee/Rm6h2gK"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 mt-4 md:mt-6 text-gray-800 font-bold hover:text-gray-900 transition-colors cursor-pointer text-sm md:text-base"
        >
          <i className="ri-line-fill text-lg md:text-xl"></i>
          LINEでもお問い合わせ可能です
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}
